import React from 'react';

export default function StepperCounter({ props: p, onAction, partId, disabled, dir }) {
  const value = p.value ?? p.count ?? 1;
  const min = p.min ?? 1;
  const max = p.max ?? 10;
  const field = p.field || 'value';

  const change = (delta) => {
    const next = Math.min(max, Math.max(min, value + delta));
    onAction?.({
      actionId: 'stepper.change',
      mode: 'patch',
      payload: { field, value: next },
      partId,
    });
  };

  return (
    <div className="ui-stepper" dir={dir}>
      {p.label && <span className="ui-stepper-label">{p.label}</span>}
      <button type="button" disabled={disabled || value <= min} onClick={() => change(-1)}>−</button>
      <span className="ui-stepper-value">{value}</span>
      <button type="button" disabled={disabled || value >= max} onClick={() => change(1)}>+</button>
    </div>
  );
}
